var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0286 13C11.304 13 9.82768 12.4021 8.59958 11.2063C7.37149 10.0105 6.75744 8.57307 6.75744 6.8939C6.75744 5.21472 7.37149 3.77725 8.59958 2.58147C9.82768 1.3857 11.304 0.787811 13.0286 0.787811C14.7531 0.787811 16.2294 1.3857 17.4575 2.58147C18.6856 3.77725 19.2997 5.21472 19.2997 6.8939C19.2997 8.57307 18.6856 10.0105 17.4575 11.2063C16.2294 12.4021 14.7531 13 13.0286 13ZM0.486328 22.1591V20.9379C0.486328 20.0729 0.715224 19.2781 1.17302 18.5535C1.63081 17.8289 2.23806 17.2753 2.99477 16.8926C4.61481 16.1039 6.26098 15.5126 7.93328 15.1188C9.60557 14.725 11.304 14.5275 13.0286 14.5265C14.7531 14.5255 16.4515 14.7229 18.1238 15.1188C19.7961 15.5147 21.4423 16.1059 23.0623 16.8926C23.8201 17.2742 24.4279 17.8279 24.8857 18.5535C25.3435 19.2791 25.5718 20.0739 25.5708 20.9379V22.1591C25.5708 22.9987 25.264 23.7177 24.6505 24.3161C24.037 24.9145 23.2986 25.2132 22.4352 25.2122H3.62189C2.75961 25.2122 2.02171 24.9135 1.40818 24.3161C0.794658 23.7187 0.487373 22.9997 0.486328 22.1591Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProfile);
export default __webpack_public_path__ + "static/media/ic_profile.9f8ea2ba0847ce6219e37bba8b5923c9.svg";
export { ForwardRef as ReactComponent };